var map = {
	"./doc-icon.svg": "defb",
	"./hocr-icon.svg": "184e",
	"./htm-icon.svg": "3efb",
	"./html-icon.svg": "f8e3",
	"./img-icon.svg": "7310",
	"./json-icon.svg": "a4be",
	"./msg-icon.svg": "dd28",
	"./pdf-icon.svg": "7a14",
	"./ppt-icon.svg": "72b1",
	"./srt-icon.svg": "8728",
	"./txt-icon.svg": "52c7",
	"./unknown-icon.svg": "65e0",
	"./xlf-icon.svg": "4e2d",
	"./xlm-icon.svg": "0c6d",
	"./xls-icon.svg": "f9e2",
	"./xltm-icon.svg": "c2b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "085c";